define('lib/progress-component/show-progress',['require','exports','module','api-access','lodash','moment'],function (require, exports, module) {
    var userApi = require('api-access').user;
    var _ = require('lodash');
    var moment = require('moment');

    function hasBeenUserFor30Days() {
        return userApi.me().then(function (me) {
            var today = moment();
            var joinDay = moment(parseInt(me.createTime, 10));

            return today.diff(joinDay, 'days') >= 30;
        });
    }

    function userHasBeta() {
        return userApi.settings().then(function (settings) {
            return settings.roomsProvisioned && settings.roomsEnabled;
        });
    }

    function isCompleted() {
        return userApi.settings().then(function (settings) {
            return settings.hasCompletedGSU;
        });
    }

    function showProgress() {
        return $.when(isCompleted(), userHasBeta(), hasBeenUserFor30Days())
            .then(function (isComplete, hasBeta, is30DayUser) {
                return ((_.contains(navigator.userAgent.toLowerCase(), 'win') ||
                   _.contains(navigator.userAgent.toLowerCase(), 'mac')) &&
                   !isComplete &&
                   !hasBeta &&
                   !is30DayUser);
            });
    }

    module.exports = showProgress;
});

